import { useTranslations } from "next-intl";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import closetStates from "@utils/constants/closetStates";
import LoadMoreClosets from "./LoadMoreClosets";
import CurrentCloset from "./CurrentCloset";
import PreviousClosets from "./PreviousClosets";

function Closets({ allLoaded, loadNextPage, prevClosets, reloadPrevCloset }) {
  const tClosets = useTranslations("closets");
  const tAccounts = useTranslations("accounts");

  const customizableCloset = useCustomizableCloset();

  if (
    (!customizableCloset?.id || customizableCloset?.state === closetStates.readyToChange) &&
    prevClosets.length === 0
  ) {
    return <p className="py-4 text-center">{tClosets("no_current_closet")}</p>;
  }

  return (
    <section>
      <h2 className="pb-2 mb-4 d-none d-lg-block">{tAccounts("title_closets")}</h2>

      <CurrentCloset />
      <PreviousClosets
        prevClosets={prevClosets}
        reloadPrevCloset={reloadPrevCloset}
      />
      <LoadMoreClosets
        prevClosets={prevClosets}
        loadNextPage={loadNextPage}
        allLoaded={allLoaded}
      />
    </section>
  );
}

export default Closets;
